import {useFetchRushGlobalScoresQuery} from '@api';
import {RushTypes} from '@types';
import {useRushQueryParams} from '@utils';
import {RushScoreTable} from './RushScoreTable';

export const RushTabGlobal = () => {
    const {rushType, filter, sort, setSort} = useRushQueryParams();

    const {
        data: globalScores,
        isFetching,
        isError,
        refetch,
    } = useFetchRushGlobalScoresQuery({
        rushType: rushType ?? RushTypes.TYPE_3_MINUTES,
        filter,
        sort,
        limit: 20,
    });

    return (
        <RushScoreTable
            data={globalScores?.entries || []}
            sort={sort}
            setSort={setSort}
            isLoading={isFetching}
            isError={isError}
            onRetry={refetch}
        />
    );
};
